// Small indicator dot for Indian menu convention:
//   veg → green, non-veg → red, anything else → nothing.
// Renders a bordered square with a coloured dot inside (classic FSSAI style).

export default function DietaryMark({ value, size = 12, className = "", title }) {
  if (value !== "veg" && value !== "non-veg") return null;
  const color = value === "veg" ? "hsl(148 55% 34%)" : "hsl(6 68% 45%)";
  return (
    <span
      role="img"
      aria-label={value === "veg" ? "Vegetarian" : "Non-vegetarian"}
      title={title || (value === "veg" ? "Vegetarian" : "Non-vegetarian")}
      data-testid={`dietary-${value}`}
      className={`inline-flex items-center justify-center shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        border: `1.5px solid ${color}`,
        borderRadius: 2,
      }}
    >
      <span
        style={{
          display: "block",
          width: Math.max(3, size - 7),
          height: Math.max(3, size - 7),
          borderRadius: 999,
          background: color,
        }}
      />
    </span>
  );
}
